/**
 * Compte a rebours plein ecran. Le chiffre vient de l'heure serveur, comme tous
 * les autres timers, donc les onglets sont synchrones a la frame pres.
 */
import { useEffect, useRef, useState, type ReactElement } from 'react';
import { useT } from '../locales/useT.js';
import { connection } from '../net/connection.js';
import { Screen } from '../ui/Screen.js';

export function CountdownScreen({ endsAt }: { endsAt: number | null }): ReactElement {
  const t = useT();
  const [value, setValue] = useState(3);
  const lastRef = useRef(3);

  useEffect(() => {
    if (endsAt === null) return;
    let raf = 0;
    const frame = (): void => {
      const seconds = Math.max(Math.ceil(connection.remaining(endsAt) / 1000), 0);
      // setState seulement au changement de seconde : 3 rendus, pas 180.
      if (seconds !== lastRef.current) {
        lastRef.current = seconds;
        setValue(seconds);
      }
      raf = requestAnimationFrame(frame);
    };
    raf = requestAnimationFrame(frame);
    return () => cancelAnimationFrame(raf);
  }, [endsAt]);

  return (
    <Screen name="countdown">
      <main className="countdown">
        <p className="countdown__label">{t('countdown.ready')}</p>
        <p className="countdown__value" key={value}>
          {value > 0 ? value : ''}
        </p>
      </main>
    </Screen>
  );
}
